import { render, staticRenderFns } from "./TranslationDropdownWrapper.vue?vue&type=template&id=9511dc78&scoped=true&"
import script from "./TranslationDropdownWrapper.vue?vue&type=script&lang=js&"
export * from "./TranslationDropdownWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TranslationDropdownWrapper.vue?vue&type=style&index=0&id=9511dc78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9511dc78",
  null
  
)

export default component.exports